import { VisibilityContext } from '../../vendor/react-horizontal-scrolling-menu';

type ScrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;

const touchPadDeltaYThreshold = 15;

export const useWheel = () => {
  // eslint-disable-next-line unicorn/consistent-function-scoping
  const onWheel = (apiObject: ScrollVisibilityApiType, ev: React.WheelEvent) => {
    const isTouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < touchPadDeltaYThreshold;

    if (isTouchpad) {
      ev.stopPropagation();
      return;
    }

    if (ev.deltaY < 0) {
      apiObject.scrollNext();
    } else {
      /* istanbul ignore next */
      if (ev.deltaY > 0) {
        apiObject.scrollPrev();
      }
    }
  };

  return { onWheel };
};
